import * as yup from 'yup'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { PatternValidate } from 'src/app/shared/utils'

function generateValidationSchema(t: any) {
  const validationSchema = yup
    .object()
    .shape({
      clientNames: yup
        .string()
        .nullable()
        .required(
          t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
            Required_Field: `${t('ACHExceptionRule:client.error')}`,
          }),
        ),
      accountNames: yup.array().min(
        1,
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ACHExceptionRule:account.error')}`,
        }),
      ),
      ruleType: yup.string().required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ACHExceptionRule:ruleType.title')}`,
        }),
      ),
      creditOrDebit: yup.string().required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ACHExceptionRule:creditOrDebit.title')}`,
        }),
      ),
      amountFrom: yup
        .string()
        .nullable()
        .matches(
          PatternValidate.decimalPattern,
          t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_AMOUNT_FORMAT, {
            Object: `${t('ACHExceptionRule:amountFrom.title')}`,
          }),
        ),
    })
    .when((values, schema: any) => {
      const schemaUpdated = {
        amountTo: yup
          .string()
          .nullable()
          .matches(
            PatternValidate.decimalPattern,
            t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_AMOUNT_FORMAT, {
              Object: `${t('ACHExceptionRule:amountTo.title')}`,
            }),
          )
          .test(
            'amountTo',
            t('SystemMessages:' + SYSTEM_MESSAGE_IDS.AMOUNT_TO_MUST_EQUAL_OR_GREATER_THAN_AMOUNT_FROM),
            (value: any) => {
              return value === '' || Number(value) >= Number(values[0].amountFrom)
            },
          ),
      }

      return schema.shape(schemaUpdated)
    })
  return validationSchema
}

export { generateValidationSchema }
